import type {FormEvent} from 'react';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {appPaths} from '@/config/appPaths';
import {authService} from '@/services/authService';
import type {AfriexLoginRequest} from '@/types';
import {getErrorMessage} from '@/utils/errorMessage';
import {showErrorMessage} from '@/utils/showErrorMessage';

const useLogin = () => {
  const navigate = useNavigate();
  const nextScreen = `/${appPaths.verifyOtp}`;

  const [loginCredentials, setLoginCredentials] = useState<AfriexLoginRequest>({
    email: '',
    password: '',
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const {name, value} = event.target;
    setLoginCredentials({...loginCredentials, [name]: value});
  };

  async function handleLogin(event: FormEvent<HTMLFormElement>) {
    try {
      event.preventDefault();
      setIsLoading(true);
      const nonceResponse = await authService.sendLogin(loginCredentials);
      localStorage.setItem('nonce', nonceResponse.nonce);
      localStorage.setItem('logging-in', loginCredentials.email);
      // `navigate` returns `void | Promise<void>` depending on router mode.
      // Awaiting it inside the existing try keeps the redirect the last step of
      // a successful login and routes a failed navigation into the same handler
      // as the rest of this function.
      await navigate(nextScreen, {replace: true});
    } catch (error) {
      setIsLoading(false);
      showErrorMessage(
        getErrorMessage(error, 'Error Logging in: Contact Engineering'),
      );
    }
  }

  return {
    handleChange,
    handleLogin,
    isLoading,
  };
};
export type LoginFormProps = ReturnType<typeof useLogin>;

export default useLogin;
